import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import locale from './locale'
import moment from 'moment';
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import AnnouncementModal from 'template/Modals/Announcement'
import __R, { userCan } from 'containers/__R'
import './AnnouncementCard.scss'

class AnnouncementCard extends React.Component {
  constructor(props) {
    super(props);

  }

  renderSendTo(){
    const {data} = this.props;
    const {send_to} = data;

    if(send_to == 'all'){
      return __('All Teachers and Students', locale)
    } else {
      return(
        send_to.map((cls, index) => {
          return (
            <span key={index} className='send-to-name'>{cls.class_name}</span>
          )
        })
      )
    }
  }

  render() {
    const {data, deleteAnnouncement, updateAnnouncement, announcementState} = this.props;
    const {title, creator_name, created_at, updated_at, content, send_to, id, state} = data;
    let publishedTime = moment(created_at).format(__('MMM DD, YYYY', locale))
    let cardState = state == 0 ? 'draft' : 'published'

    return (
      <div className='announcement-card-list'>
        <div className={`card`} onClick={() => {
          let class_id_list;
          if(send_to == 'all'){
            class_id_list = 'all'
          } else {
            class_id_list = []
            send_to.map((cls) => {
              class_id_list.push(cls.class_id)
            })
          }
          if(state == 0 ){
            if(userCan('edit_announcement')){
              AnnouncementModal({data, class_id_list, allowEdit: true})
            } else {
              alert.warning(__('You do not have permission to edit announcement', locale))
              .then(() => {})
              .catch(() => {})
            }
          } else {
            AnnouncementModal({data, class_id_list, allowEdit: false})
          }
        }}>
          <div>
            <div className='title'>{title}</div>
          </div>
          <div className='publish-info'>
            <span>{__('Publisher: {name}', locale, {name: creator_name})}</span>
            <span className='date'>
              {__('Published Time: {time}', locale, {time: publishedTime})}
            </span>
          </div>
          <div className='content' dangerouslySetInnerHTML={{ __html:content }}></div>
          <div className='card-footer'>
            <div className='send-to'>
              {__('Send To: ', locale)}
              {this.renderSendTo()}
            </div>
            {state == 0 && <__R can='delete_announcement' by='alert'>
              <i className='fa icon-trash pull-right' onClick={(e) => {
                e.stopPropagation()

                confirm(__('Proceed to delete announcement?', locale))
                .then(() => {
                  deleteAnnouncement(id)
                })
                .catch((err) => {console.log(err)})
              }}></i>
            </__R>}
            {state == 0 && <__R can='edit_announcement' by='alert'>
              <button className='send-btn pull-right' onClick={(e) => {
                e.stopPropagation()

                let class_id_list;
                if(send_to == 'all'){
                  class_id_list = 'all'
                } else {
                  class_id_list = []
                  send_to.map((cls) => {
                    class_id_list.push(cls.class_id)
                  })
                }

                confirm(__('Proceed to publish announcement?', locale))
                .then(() => {
                  updateAnnouncement(id, {send_to: 'all', class_id_list, title, content, state: 'published'})
                })
                .catch((err) => {console.log(err)})
              }}>
                {__('Send', locale)}
              </button>
            </__R>}
            {state == 1 && <span className='pull-right sent'>
              {__('Sent', locale)}
            </span>}
          </div>
        </div>
      </div>
    )
  }
}

export default AnnouncementCard;



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/AnnouncementCard.js